import Api from './api.service';
export default {
  getVersion() {
    return Api().get('/app-versions');
  }
};
